import { render, staticRenderFns } from "./ExamineeReportModal.vue?vue&type=template&id=64e1c8a4&scoped=true&"
import script from "./ExamineeReportModal.vue?vue&type=script&lang=js&"
export * from "./ExamineeReportModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e1c8a4",
  null
  
)

export default component.exports